"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const emotion_1 = require("emotion");
const usePref_1 = __importDefault(require("../hooks/usePref"));
/**
 * Enhance ExpandableSection:
 *  * add rememberKey -- if set it will remember whether it should be open
 *    across page loads/sessions
 *  * prevent user-selection of the header
 */
exports.default = ({ rememberKey, ...props }) => {
    const [expanded, setExpanded] = usePref_1.default(`ExpandableSection.${rememberKey}`, false);
    if (rememberKey) {
        props.expanded = expanded;
        props.onChange = ({ detail: { expanded } }) => setExpanded(expanded);
    }
    props.header = react_1.default.createElement("span", { className: emotion_1.css({ userSelect: 'none' }) }, props.header);
    return react_1.default.createElement(polaris_1.ExpandableSection, Object.assign({}, props));
};
//# sourceMappingURL=ExpandableSection.js.map